import template from "./app.html";
import "./app.css";

const appComponent = {
  template,
  restrict: "E",
};

export default
appComponent;
